module.exports = __webpack_public_path__ + "img/3.721fdfb3.png";